import { Grid } from '@mui/material';
import { isUndefined } from 'lodash';
import { FunctionField, SimpleShowLayout } from 'react-admin';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { AccountHolder } from 'src/models';

export const DisclosureDetails = ({ record }: { record: AccountHolder }) => {
  return (
    <Grid container direction='row' spacing={2}>
      <Grid item md={6}>
        <SimpleShowLayout>
          <FunctionField
            record={record}
            render={(record: AccountHolder) => {
              const industryEmployed = record.disclosure?.industryEmployed;

              if (!isUndefined(industryEmployed) && industryEmployed === false) {
                return 'No';
              }

              return industryEmployed?.firmName;
            }}
            label='Industry Employed Firm Name'
          />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <FunctionField
            record={record}
            render={(record: AccountHolder) => {
              const stakeholder = record.disclosure?.stakeholder;

              if (!isUndefined(stakeholder) && stakeholder === false) {
                return 'No';
              }

              return stakeholder?.tickerSymbol;
            }}
            label='Stakeholder'
          />
        </SimpleShowLayout>
      </Grid>
    </Grid>
  );
};
